/**
 * Converts a given company name string to title case.
 * Each word in the input string will have its first character capitalized and the rest in lowercase.
 *
 * @param company - The company name to convert to title case.
 * @returns The company name in title case format.
 */
export const toTitleCase = (company: string) =>
	company
		.toLowerCase()
		.split(' ')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
